(function ($, konto) {
    var KontoBase = function (unique) {
        var that = this;
        
        that.unique = unique;
        that.progId = $("#progId").text();
        that.cachePrefix = "cache-" + that.progId;
        that.cachePrefixOld = "cache";

        $(window).data("windowUnique", unique);
               
        that._readyFuncArray = [];
        that._readyExecuted = false;
        // Koristi se samo za async AJAX 
        that._readyCanExecute = false;
        that._loadedFuncArray = [];
        that._loadedExecuted = false;
        that._beforeLoadedFuncArray = [];
        that._beforeLoadedExecuted = false;
        that._submitEventsFuncArray = [];
        that._provjeriValue = false;        

        /**
         * Ovdje su pohranjene sve komponente.
         * TODO: Arrayjevi, klase.
         * Treba riješiti: 
         *  fld-ime
         *  fld-arr[]        
         *  fld:klasa-ime
         *  fld:klasa-arr[]
         */
        that.components = {};
        
        /**
         * Označava asinkroni AJAX. Sinkroni AJAX je deprecated i pitanje je kad će biti izbačen pa sve treba prebaciti na
         * sinkrone zahtjeve.
         * 
         * Defaultna vrijednost je za sad false.
         */
        that._ajaxAsync = false;
        that._ajaxQueue = that.createAjaxQueue();
        
        that._scrollAfterFocus = false;       
        
        that.activeElement = null; 

        // root element
        that.root = $(".root-" + that.unique);
        
        /**
         * Event koji se izvršava u slučaju AJAX navigacije.
         * TODO: zgodna bi bila funkcija getEventName
         * 
         * Ovaj kod unbinda event, a bindani eventi bi se tek trebali pozvati.
         * To radi, ali ako ikad prestane...
         */
        $(window).on("beforepageunload." + unique, function () {
            $.each(KontoBase._instances, function (key, value) {
                if (value.remove)
                    value.remove(); 
                delete KontoBase._instances[key];
            });
            KontoBase._instances = {};
            that = null;
        });
        
        $("body").on("kontoformloaded." + unique, function () {
            that.overrideJQuerySerialization();
            that.init();
            
            $("body").trigger("kontoform." + unique);           
        });     
    };
    
    konto.KontoBase = KontoBase;
    
    /**
     * Static variables/methods
     */
    KontoBase._instances = {};
    KontoBase.get = function (unique) {
        var instance = KontoBase._instances[unique];
        return instance;
    };
    KontoBase.getByControllerAction = function (i_controller, i_action) {
    	if (typeof i_controller === 'undefined' || typeof i_action === 'undefined') {
    		console.log('GRESKA: Controller ili Action nisu definirani');
    		return false;
    	}

		var instance = {};
		
    	$.each(KontoBase._instances, function(unique, obj) {
    		if (obj.controller == i_controller && obj.baseActionName == i_action) {
    			instance = KontoBase._instances[unique];
			 	return;
			}	
    	});
    	
    	return instance;
		
    };
    
    KontoBase.create = function (unique, Class, params) {
        KontoBase._instances[unique] = new Class(unique, params);
        return KontoBase._instances[unique];  
    };
    
    /** 
     * Metoda za izbjegavanje self executing funkcije.
     * 
     * @param ref - string: unique vrijednost
     *              object: instance varijabla
     */
    KontoBase.with = function (ref, f) {
        var instance;
        if (typeof ref === "string")
            instance = KontoBase.get(ref);
        else if (typeof ref === "object" && ref instanceof KontoBase)
            instance = ref;
        else {
            return;
        }
            
        if (typeof f === "function") {
			if (instance == undefined){
				return;
			}else{
				f.call(instance, instance);	
			}            
        }
    };
    
    /**
     * Private methods
     */
    function sel(selector) {
        return $(selector, this.root);
    }
    
    /**
     * Pomoćna funkcija kod poziva šifarnika.
     */
    function getUnosFilter(filters, userFilter) {
    	
        var filter = {};
        filter.logic = "and";
        filter.filters = [];
        $.each(filters, function (key, value) {
            var f = {};
            f.operator = "contains";
            f.value = value;
            f.field = key;
            filter.filters.push(f);
        });
        
        if (userFilter) {
            fullFilter = {
                logic: "and",
                filters: [userFilter, filter]
            };
        }
        else {
            fullFilter = filter;
        }
        return fullFilter;
    }
    
    function destroy() {
        $(window).off("." + this.unique);
        $("body").off("." + this.unique);
    }
    
    
    /**
     * Public methods
     */
    KontoBase.prototype = {
        sel: sel,
        $: sel,
        /**
         * Destruktor
         */
        _remove: destroy,
        /**
         * Funkcija koja inicijalizira elemente na unosima/šifarnicima. Kendo i ostali.
         */
        init: function (root) {
            var that = this;      
            var datetime_allowed_chars = "0123456789";	
			
            root = root || this.root;
                                   
            /**
             * konto-datetime-separate nova klasa koja će napraviti polje koje postoji hidden i kreirati dva polja jedno za datum drugo za vrijeme ostalo mora funkcionirati kao prije
             * Dakle treba dodati "konto-datetime-separate" unutar class za objekte "konto-input-datetime" ili "konto-input-datetime-ss"
             * Pretpostavka jest da se navedeni objekt mora nalaziti unutar "div class='form-group'" te mora imati pridruženi "label class='control-label'"
             */                            
             root.find("input.konto-datetime-separate")
             	.each(function() {            		
					$(this).kontoDateTimeSeparateHide();        		
					$(this).kontoDateTimeSeparateCreate();					
             	});
                                           
            root.find("input").attr("autocomplete", "off");
            
            // Inicijalizacija drop downa. Definitivno mora biti prije postavljanja vrijednosti
            // objekta.
            root.find(".konto-dropdownlist").each(that.initDropDown);      
			root.find(".konto-input").addClass("form-control"); 
			root.find(".float-value").attr("inputmode", "decimal");
			root.find(".int-value").attr("pattern", "[0-9]*").attr("inputmode", "numeric"); 			
			
            root.find(".konto-input").keydown(function(e) {              	
                if ($(this).isKontoReadonly()){
                	var code = e.keyCode || e.charCode;
                	if(e.ctrlKey && ((code == 67) || (code == 99)) ) {  //C = 67; c = 99 (preama ASCII)
                		//napravi copy	
                	}else{
                		e.preventDefault();	
                	}
                	return; 
            	} 
             });	
             
             /*
             * Za sad je napravljeno preko klase, ako želimo na sve samo treba maknuti klasu iz finda
             */
             root.find(".konto-input.upozoriNaVodeceRazmake").on('blur', function(e){
				KUtils.upozoriNaVodeceRazmake($(this));
			 });
                     
            /**
             * 		FUNKCIJE KOJE PROŠIRUJU JQUERY SET FUNKCIJA
             * 		Mogu se nakačiti na bilo koji jQuery object no većinom su specifične
             * 
             * 		Primjer uportebe:
             * 		$(jQueryObject).setRadioButtonReadonly(); 
             */  
                         
			$.styleSheetExist = function (f) {
        		var hasstyle = false;
        		var fullstylesheets = document.styleSheets;
        		for (var sx = 0; sx < fullstylesheets.length; sx++) {
            		var sheetclasses = fullstylesheets[sx].rules || document.styleSheets[sx].cssRules;
            		for (var cx = 0; cx < sheetclasses.length; cx++) {
                		if (sheetclasses[cx].selectorText == f) {
                    		hasstyle = true; break;
                    		//return classes[x].style;              
                		}
            		}
        		}
        		return hasstyle;
    		};             	
               
			/**
			 * Postavljanje konto-more klase i eventa
			 */	    
			 			 		 	
			 root.find(".konto-more")
			 	.each(function(){
					$(this).kontoMoreCreate();			
			 	})
			 	.change(function(){
					$(this).kontoMoreChange();		
			 	});   
			 root.find(".konto-more-a")
			 	.click(function(){			 		
					$(this).kontoMoreClick();				 		
			 	}); 
                     
            that.maskirajDatume(root);   
            
             /**
              * Blur: event za sada kontrolira samo promjenu objekta te poziva bindanu change funkciju, za sada funkcije moraju biti bindane direktno na objekt, bnindanje na data("kendo...") ne radi
              * Keydown: Fix za navigaciju Enter-om, nije radila ukoliko se klikne na neki od automatski dodanih objekata 
              *	Each: Micanje dodatnog obruba na automatski kreiranim elementima za datum i vrijeme 
             */  
         	root.find("input.konto-input-date-separate")           	
         		.focus(function(e) {
					$(this).kontoDateSeparateFocus(e);
         		})
         		.blur(function(e) {              			     			
					$(this).kontoDateSeparateBlur(e);           			 			
         		})
         		.keydown(function(e) {
					$(this).kontoDateSeparateKeyDown(root, e);        			
         		})
				.mousedown(function() { 
					$(this).kontoDateSeparateMouseDown();	
				})        
				.mouseup(function() { 
					$(this).kontoDateSeparateMouseUp();	
				})  					     		
         		.each(function() {                 	
					$(this).kontoDateSeparateEach();					
         		});
             	            							             	
         	root.find("input.konto-input-time-separate")  
         		.focus(function(e) {
					$(this).kontoTimeSeparateFocus(e);
         		})             	      	
         		.blur(function(e) {  
					$(this).kontoTimeSeparateBlur(e);            			         			
         		})                 		         	
         		.keydown(function(e) {
					$(this).kontoTimeSeparateKeyDown(root, e);        			
         		})        
				.mousedown(function() { 
					$(this).kontoTimeSeparateMouseDown();
				})        
				.mouseup(function() { 
					$(this).kontoTimeSeparateMouseUp();
				})
         		.each(function() {                 	
					$(this).kontoTimeSeparateEach();					             			          	           		
         		});     
             	
       		root.find("input.konto-input-time-ss-separate")    
         		.focus(function(e) {
					$(this).kontoTimeSSSeparateFocus(e);
         		})              		  		
         		.blur(function(e) {            			
					$(this).kontoTimeSSSeparateBlur(e);	            			     			
         		})            		            		
         		.keydown(function(e) {
					$(this).kontoTimeSSSeparateKeyDown(root, e);         			
         		})           	
				.mousedown(function() { 
					$(this).kontoTimeSSSeparateMouseDown();
				})        
				.mouseup(function() { 
					$(this).kontoTimeSSSeparateMouseUp();	
				})               			      	
         		.each(function() {                 	
					$(this).kontoTimeSSSeparateEach();           			
         		});             
             		                                                                         
               
			root.find("input.konto-input")
				.focus(function(){
					that.activeElement = this; 
				})
				.blur(function() {
					if(this == that.activeElement){					
				        if (KUtils.InputIsRequiredAndEmpty($(this))){
	                        $(this).closest(".form-group").addClass("is-invalid"); 
	                        $(this).addClass("border-danger");
	                    }
	                    else {
	                        $(this).closest(".form-group").removeClass("is-invalid"); 
	                    	$(this).removeClass("border-danger"); 
	                    }	
	               	}
				});						  
                
			root.find(".sifarnik-group").find("input")
				.focus(function(){
					that.activeElement = this; 
				})			
				.blur(function() {
					var frm_grp = $(this).closest(".form-group");
					if(this == that.activeElement){
				        if (KUtils.InputIsRequiredAndEmpty($(this))){
	                        frm_grp.addClass("is-invalid"); 
	                        $(this).addClass("border-danger");
	                        frm_grp.find(".input-group-text").addClass("border-danger"); 
	                        //frm_grp.find(".sifarnik-button").click(); 
	                    }
	                    else {
	                        frm_grp.removeClass("is-invalid"); 
	                    	$(this).removeClass("border-danger"); 
							frm_grp.find(".input-group-text").removeClass("border-danger");                    	
	                    }							
					}						
				})
                .each(function () {
                	// $(this).closest(".form-group").after('<div class="invalid-feedback">Polje je zahtjevano.</div>'); // bootstrap 4 validacija 
                });                 				                                        
                    
            // required boja pozadine
			root.find("input")	
                .each(function () {
					KUtils.SetRequired(this);     	
                });
                
                                      
             /**
             * definicije maski za unos za sve vrste date&time pickera
             */
            root.find("input.konto-input-year").kendoDatePicker({
	            start: "decade",
	
	            // defines when the calendar should return date
	            depth: "decade",
	
	            // display month and year in the input
            	format: "yyyy",          	
            });
            
            root.find("input.konto-input-month").kendoDatePicker({
	            start: "year",
	
	            // defines when the calendar should return date
	            depth: "year",
	
	            // display month and year in the input
            	format: "MM - MMMM",          	
            }); 
            
            root.find("input.konto-input-date").kendoDatePicker({
				format: "dd.MM.yyyy"	
			})           
            
            root.find("input.konto-input-datetime").kendoDateTimePicker({
            	format: "dd.MM.yyyy HH:mm"            	
            });
            
            root.find("input.konto-input-datetime-ss").kendoDateTimePicker({
            	format: "dd.MM.yyyy HH:mm:ss"            	
            });
           
            root.find("input.konto-input-time").kendoTimePicker({
            	format: "HH:mm"            	
            });
            
            root.find("input.konto-input-time-ss").kendoTimePicker({
            	format: "HH:mm:ss"            	
            }); 
                            
            // Prilikom focusa unutar inputa označava cijeli text.
            root.find("input[type=text]")
                .focus(function () {              	
                	$(this).data("shouldSelect", true);
                	if (that._scrollAfterFocus){
                		con = $('form').last().closest('.modal-dialog');
                		KUtils.setScrollVertical(con, $(this));
                	}
                })
                .click(function() {
                    if ($(this).data("shouldSelect")) {
                        $(this).select();
                    }
                    else { }
                    $(this).data("shouldSelect", false);
                });   
                
				root.find("input[type=tel]")
	                .focus(function () {              	
	                	$(this).data("shouldSelect", true);
	                	if (that._scrollAfterFocus){
	                		con = $('form').last().closest('.modal-dialog');
	                		KUtils.setScrollVertical(con, $(this));
	                	}
	                })
	                .click(function() {
	                    if ($(this).data("shouldSelect")) {
	                        $(this).select();
	                    }
	                    else { }
	                    $(this).data("shouldSelect", false);
	                });                           
               
             root.find("input.konto-input-year")
             	.keydown(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")){
                    	e.preventDefault();
                    	return; 
                	 }  
                 })
                 .change(function(e){
                 	if ($(this).prop("readonly") || $(this).prop("disabled")) return;
                 	
                 	if ($(this).data('date') || $(this).data('month')){	
                 		var datum = new Date($(this).val(), $(this).data('month')-1, $(this).data('date'));	
                 		$(this).data("kendoDatePicker").value(datum);
                 	}
                 	
                 	
                 })
                 .on('paste', function () {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;
                 })
                 .keyup(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;
                 })
                 .keypress(function(e) {	 
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;
                 });	              
             /**
             * modifikacija unosa datuma
             */
            root.find("input.konto-input-date")
                .focus(function() {          
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                       	            	                	
                	$(this).data("konto_text", $(this).val());
					$(this).data("konto_old_value", $(this).val());	              	
                })
                .change(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                                     	
                	$(this).data("konto_text", $(this).val());
                })  
				.on('paste', function () {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                     					
  					var element = this;
  					
  					setTimeout(function () {
    					var text = $(element).val();
    					
    					$(element).data("konto_text", text);
    					$(element).focus().select();
  					}, 100);
				})    
                .keydown(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")){
                    	e.preventDefault();
                    	return; 
                	 }  
                 })				                              
                .keyup(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                                     	
                	var key = e.which || e.charCode || e.keyCode;
                	
                	//brisanje text boxa za datetime
      				if($(this).val() == "__.__.____") 
                	{
                		$(this).data("konto_text", "__.__.____");	
                	}   
                	           	                   	
         			if((key == 8) || (key == 46))//backspace & delete overwrite 
        			{
       					$(this).data("konto_text", $(this).val());       				
        			}  
                }) 
				.keypress(function(e) {	
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                     					
					var key = String.fromCharCode(e.which || e.charCode || e.keyCode);     
        			    		
        			//samo dozvoljeni znakovi (tipke)
        			if(datetime_allowed_chars.indexOf(key) != -1)
        			{  					        				  				                							
						if($(this).data("konto_text") == "__.__.____")
                		{
                			var val = KUtils.formatDate(new Date(), false);
                			$(this).val(val);
                			$(this).get(0).setSelectionRange(0, 0); 
                		} 

                		var oldTekst = $(this).data("konto_text").replace(/_/g,'');          		              		
                		var day, month, year;
						var caret = $(this).get(0).selectionStart;  
        				var text = $(this).data("konto_text");
      				       				
                		if(oldTekst.length != 10)
							text = $(this).val();     				       				
      				       				
        				day = text.substring(0,2);
        				month = text.substring(3,5);
        				year = text.substring(6,10);
        					        								
        				//kursor unutar dana
						if(caret == 0)
						{
        					day = text.substring(1,2);					
						}  						     				
						if(caret == 1)
						{
        					day = text.substring(0,1);					
						}
						//kursor unutar mjeseca
						if ((caret == 3) || (caret == 2))
						{
        					month = text.substring(4,5);					
						}         				
						if(caret == 4)
						{
        					month = text.substring(3,4);					
						}					
					    //kursor unutar godine
					    if ((caret == 6) || (caret == 5))
						{
        					year = text.substring(7,10);					
						} 						
						if(caret == 7)
						{
        					year = text.substring(6,7) +  text.substring(8,10);					
						} 
						if(caret ==8)
						{
        					year = text.substring(6,8) +  text.substring(9,10);					
						} 
						if((caret == 9) || (caret == 10))
						{
        					year = text.substring(6,9);					
						} 					
					
       					var newtext = day + "." + month + "." + year;
       				
       					$(this).val(newtext);
       					
       					if (caret == 0){
							var konto_t = key + newtext; 	   
						}else if (caret >= newtext.length){
							var konto_t =  newtext + key; 	
						}else{
							var konto_t = newtext.substring(0, caret) + key + newtext.substring(caret, newtext.length);
						}
       						
       					$(this).data("konto_text", konto_t);
       				       				
       					$(this).get(0).setSelectionRange(caret, caret);
                   		$(this).data("shouldSelect", false);
               		} //kraj od allowed chars	
				});
            	
             /**
             * modifikacija unosa datuma i vremena bez sekundi
             */
            root.find("input.konto-input-datetime")
                .focus(function() {  	
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
              		                		
                	$(this).data("konto_text", $(this).val());
					$(this).data("konto_old_value", $(this).val());	                  	
                })
                .change(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
           	
                	$(this).data("konto_text", $(this).val());
                })
				.on('paste', function () {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
			
  					var element = this;
  					
  					setTimeout(function () {
    					var text = $(element).val();
    					
    					$(element).data("konto_text", text);
    					$(element).focus().select();
  					}, 100);
				})  
                .keydown(function(e) {               	
                    if ($(this).prop("readonly") || $(this).prop("disabled")){
                    	e.preventDefault();
                    	return; 
                	 }  
                 })					             
                .keyup(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
               	
                	var key = e.which || e.charCode || e.keyCode;
                	
                	//brisanje text boxa za datetime
      				if($(this).val() == "__.__.____ __:__")
                	{
                		$(this).data("konto_text", "__.__.____ __:__");	
                	}   
                	
         			if((key == 8) || (key == 46))//backspace & delete overwrite 
        			{
       					$(this).data("konto_text", $(this).val());       				
        			}                  	           	   
                }) 
				.keypress(function(e) {	 
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
				
					var key = String.fromCharCode(e.which || e.charCode || e.keyCode);                  					
        			    				
        			//samo dozvoljeni znakovi (tipke)
        			if(datetime_allowed_chars.indexOf(key) != -1)
        			{    		
						if($(this).data("konto_text") == "__.__.____ __:__")
                		{
                			var val = KUtils.formatDateTime(new Date(), false);
                			$(this).val(val);
                			$(this).get(0).setSelectionRange(0, 0);               		 
                		}         				
        						                		
                		var day, month, year, hour, minute;
           					
           				var oldTekst = $(this).data("konto_text").replace(/_/g,''); 	
        				var text = $(this).data("konto_text");
						var caret = $(this).get(0).selectionStart;        				
        				
                		if(oldTekst.length != 16)
							text = $(this).val();          				
        				
        				day = text.substring(0,2);
        				month = text.substring(3,5);
        				year = text.substring(6,10);
        				hour = text.substring(11,13);
        				minute = text.substring(14,16);
        				
        				//kursor unutar dana
						if(caret == 0)
						{
        					day = text.substring(1,2);					
						}  						     				
						if(caret == 1)
						{
        					day = text.substring(0,1);					
						}       										
						//kursor unutar mjeseca
						if ((caret == 3) || (caret == 2))
						{
        					month = text.substring(4,5);					
						}         				
						if(caret == 4)
						{
        					month = text.substring(3,4);					
						}											
					    //kursor unutar godine
					    if ((caret == 6) || (caret == 5))
						{
        					year = text.substring(7,10);					
						} 						
						if(caret == 7)
						{
        					year = text.substring(6,7) +  text.substring(8,10);					
						} 
						if(caret ==8)
						{
        					year = text.substring(6,8) +  text.substring(9,10);					
						} 
						if(caret == 9)
						{
        					year = text.substring(6,9);					
						} 						
						//kursor unutar sata
						if((caret == 11) || (caret == 10))
						{
        					hour = text.substring(12,13);					
						}     						   				
						if(caret == 12)
						{
        					hour = text.substring(11,12);					
						}																		
						//kursor unutar minute
						if((caret == 13) || (caret == 14))
						{
        					minute = text.substring(15,16);					
						}        				
						if((caret == 15) || (caret == 16)) //kad ima sekundi onda je vjerojatno 17
						{
        					minute = text.substring(14,15);					
						}												
				
       					var newtext = day + "." + month + "." + year + " " + hour + ":" + minute;
       				
       					$(this).val(newtext);	
       					
       					if (caret == 0){
							var konto_t = key + newtext; 	   
						}else if (caret >= newtext.length){
							var konto_t =  newtext + key; 	
						}else{
							var konto_t = newtext.substring(0, caret) + key + newtext.substring(caret, newtext.length);
						}
       					
       					$(this).data("konto_text", konto_t);
       				       				
       					$(this).get(0).setSelectionRange(caret, caret);
                   		$(this).data("shouldSelect", false);
               		} //kraj od allowed chars	
				})
	            .blur(function () {
	                var date = kendo.parseDate($(this).val());
	                if (($(this).val() !== "" && date === null) || KUtils.DateNotValid(this, date)){
	                    $(this).closest(".form-group").addClass("is-invalid"); 
	                    $(this).closest(".k-picker-wrap").addClass("border-danger");
						$(this).closest(".form-group").find(".k-select").addClass("border-danger");                        
	                }
	                else {
	                    $(this).closest(".form-group").removeClass("is-invalid"); 
						$(this).closest(".k-picker-wrap").removeClass("border-danger");  
						$(this).closest(".form-group").find(".k-select").removeClass("border-danger");
	                }
	            }); 				
            	
             /**
             * modifikacija unosa datuma i vremena sa sekundama
             */
            root.find("input.konto-input-datetime-ss")
                .focus(function() {  
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                                     	
                	$(this).data("konto_text", $(this).val());
					$(this).data("konto_old_value", $(this).val());	                  	
                })
                .change(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                                     	
                	$(this).data("konto_text", $(this).val());
                })   
				.on('paste', function () {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                     					
  					var element = this;
  					
  					setTimeout(function () {
    					var text = $(element).val();
    					
    					$(element).data("konto_text", text);
    					$(element).focus().select();
  					}, 100);
				})   
                .keydown(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")){
                    	e.preventDefault();
                    	return; 
                	 } 
                 })					                            
                .keyup(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                                     	
                	var key = e.which || e.charCode || e.keyCode;
                	
                	//brisanje text boxa za datetime
      				if($(this).val() == "__.__.____ __:__:__")
                	{
                		$(this).data("konto_text", "__.__.____ __:__:__");	
                	} 
                	
                	if((key == 8) || (key == 46))//backspace & delete overwrite 
        			{
       					$(this).data("konto_text", $(this).val());       				
        			}  
                }) 
				.keypress(function(e) {	 
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                     					
					var key = String.fromCharCode(e.which || e.charCode || e.keyCode);                  		 			
        			    				
        			//samo dozvoljeni znakovi (tipke)
        			if(datetime_allowed_chars.indexOf(key) != -1)
        			{    	
        				if($(this).data("konto_text") == "__.__.____ __:__:__")
                		{
                			var val = KUtils.formatDateTime(new Date(), true);               			
                			$(this).val(val);
                			$(this).get(0).setSelectionRange(0, 0); 
                		}  
                		
                		var day, month, year, hour, minute, second;
           				
           				var oldTekst = $(this).data("konto_text").replace(/_/g,'');	
        				var text = $(this).data("konto_text");
						var caret = $(this).get(0).selectionStart; 
						
						if(oldTekst.length != 19)
							text = $(this).val();  
        				
        				day = text.substring(0,2);
        				month = text.substring(3,5);
        				year = text.substring(6,10);
        				hour = text.substring(11,13);
        				minute = text.substring(14,16);
						second = text.substring(17,19);		
        															
        				//kursor unutar dana
						if(caret == 0)
						{
        					day = text.substring(1,2);					
						}  						     				
						if(caret == 1)
						{
        					day = text.substring(0,1);					
						}       										
						//kursor unutar mjeseca
						if ((caret == 3) || (caret == 2))
						{
        					month = text.substring(4,5);					
						}         				
						if(caret == 4)
						{
        					month = text.substring(3,4);					
						}											
					    //kursor unutar godine
					    if ((caret == 6) || (caret == 5))
						{
        					year = text.substring(7,10);					
						} 						
						if(caret == 7)
						{
        					year = text.substring(6,7) +  text.substring(8,10);					
						} 
						if(caret ==8)
						{
        					year = text.substring(6,8) +  text.substring(9,10);					
						} 
						if(caret == 9)
						{
        					year = text.substring(6,9);					
						} 						
						//kursor unutar sata
						if((caret == 11) || (caret == 10))
						{
        					hour = text.substring(12,13);					
						}     						   				
						if(caret == 12)
						{
        					hour = text.substring(11,12);					
						}																		
						//kursor unutar minute
						if((caret == 13) || (caret == 14))
						{
        					minute = text.substring(15,16);					
						}        				
						if(caret == 15) 
						{
        					minute = text.substring(14,15);					
						}							
						//kursor unutar sekunde
						if((caret == 16) || (caret == 17))
						{
        					second = text.substring(18,19);					
						}        				
						if((caret == 18) || (caret == 19))
						{
        					second = text.substring(17,18);					
						}																
						
					
       					var newtext = day + "." + month + "." + year + " " + hour + ":" + minute + ":" + second;
       				
       					$(this).val(newtext);

       					if (caret == 0){
							var konto_t = key + newtext; 	   
						}else if (caret >= newtext.length){
							var konto_t =  newtext + key; 	
						}else{
							var konto_t = newtext.substring(0, caret) + key + newtext.substring(caret, newtext.length);
						}
       						
       					$(this).data("konto_text", konto_t);
       				       				
       					$(this).get(0).setSelectionRange(caret, caret);
                   		$(this).data("shouldSelect", false);
               		} //kraj od allowed chars	
				})
	            .blur(function () {
	                var date = kendo.parseDate($(this).val());
	                if (($(this).val() !== "" && date === null) || KUtils.DateNotValid(this, date)){
	                    $(this).closest(".form-group").addClass("is-invalid"); 
	                    $(this).closest(".k-picker-wrap").addClass("border-danger");
						$(this).closest(".form-group").find(".k-select").addClass("border-danger");                        
	                }
	                else {
	                    $(this).closest(".form-group").removeClass("is-invalid"); 
						$(this).closest(".k-picker-wrap").removeClass("border-danger");  
						$(this).closest(".form-group").find(".k-select").removeClass("border-danger");
	                }
	            }); 				
            
             /**
             * modifikacija unosa vremena bez sekundi
             */ 
            root.find("input.konto-input-time,input.konto-hide-time-picker")
                .focus(function() {  
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                                     	
                	$(this).data("konto_text", $(this).val());
					$(this).data("konto_old_value", $(this).val());	                  	
                })
                .change(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                                     	
                	$(this).data("konto_text", $(this).val());
                })  
				.on('paste', function () {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                     					
  					var element = this;
  					
  					setTimeout(function () {
    					var text = $(element).val();
    					
    					$(element).data("konto_text", text);
    					$(element).focus().select();
  					}, 100);
				})  
                .keydown(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")){
                    	e.preventDefault();
                    	return; 
                	 }    
                 })					                              
                .keyup(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                                     	
                	var key = e.which || e.charCode || e.keyCode;

                	//brisanje text boxa za datetime
      				if($(this).val() == "__:__")
                	{
                		$(this).data("konto_text", "__:__");	
                	}   
                	                  	           	   
         			if((key == 8) || (key == 46))//backspace & delete overwrite 
        			{
       					$(this).data("konto_text", $(this).val());       				
        			}                  	                  	           	   
                }) 
				.keypress(function(e) {	 
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                     					
					var key = String.fromCharCode(e.which || e.charCode || e.keyCode);                  		  			
        			    				
        			//samo dozvoljeni znakovi (tipke)
        			if(datetime_allowed_chars.indexOf(key) != -1)
        			{   
        			   	if($(this).data("konto_text") == "__:__")
                		{
                			var val = KUtils.formatTime(new Date());              			
                			$(this).val(val);
                			$(this).get(0).setSelectionRange(0, 0);                 		
                		}    
					
                		var hour, minute;
           					
           				var oldTekst = $(this).data("konto_text").replace(/_/g,'');  
        				var text = $(this).data("konto_text");
						var caret = $(this).get(0).selectionStart;        				
        				
        				if(oldTekst.length != 5)
							text = $(this).val();   
        				
        				hour = text.substring(0,2);
        				minute = text.substring(3,5);		
        										
        				//kursor unutar sata
						if(caret == 0)
						{
        					hour = text.substring(1,2);					
						}  						     				
						if(caret == 1)
						{
        					hour = text.substring(0,1);					
						} 

						//kursor unutar minute
						if ((caret == 3) || (caret == 2))
						{
        					minute = text.substring(4,5);					
						}         				
						if((caret == 4) || (caret == 5))
						{
        					minute = text.substring(3,4);					
						}												
						
       					var newtext = hour + ":" + minute;
       									
       					$(this).val(newtext);	
       					
       					if (caret == 0){
							var konto_t = key + newtext; 	   
						}else if (caret >= newtext.length){
							var konto_t =  newtext + key; 	
						}else{
							var konto_t = newtext.substring(0, caret) + key + newtext.substring(caret, newtext.length);
						}
       					
       					$(this).data("konto_text", konto_t);
       				       				
       					$(this).get(0).setSelectionRange(caret, caret);
                   		$(this).data("shouldSelect", false);
               		} //kraj od allowed chars	
				});
            	            
             /**
             * modifikacija unosa vremena sa sekundama
             */
            root.find("input.konto-input-time-ss,input.konto-hide-time-ss-picker")
                .focus(function() {  
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                                     		
                	$(this).data("konto_text", $(this).val());
					$(this).data("konto_old_value", $(this).val());	                  	
                })
                .change(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                                     	
                	$(this).data("konto_text", $(this).val());
                })   
				.on('paste', function () {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                     					
  					var element = this;
  					
  					setTimeout(function () {
    					var text = $(element).val();
    					
    					$(element).data("konto_text", text);
    					$(element).focus().select();
  					}, 100);
				}) 
                .keydown(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")){
                    	e.preventDefault();
                    	return; 
                	 }    
                 })					                              
                .keyup(function(e) {
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                                     	
                	var key = e.which || e.charCode || e.keyCode;
                	
                	//brisanje text boxa za datetime
      				if($(this).val() == "__:__:__")
                	{
                		$(this).data("konto_text", "__:__:__");	
                	}    

         			if((key == 8) || (key == 46))//backspace & delete overwrite 
        			{
       					$(this).data("konto_text", $(this).val());       				
        			}                  	          	   
                }) 
				.keypress(function(e) {	 
                    if ($(this).prop("readonly") || $(this).prop("disabled")) return;   
                     					
					var key = String.fromCharCode(e.which || e.charCode || e.keyCode);                  					
        			    				
        			//samo dozvoljeni znakovi (tipke)
        			if(datetime_allowed_chars.indexOf(key) != -1)
        			{    				 
        				if($(this).data("konto_text") == "__:__:__") {
                			var val = KUtils.formatTime(new Date(), true);              			
                			$(this).val(val);
                			$(this).get(0).setSelectionRange(0, 0);                 		
                		}  
                		
                		var hour, minute, second;
           				
           				var oldTekst = $(this).data("konto_text").replace(/_/g,'');	
        				var text = $(this).data("konto_text");
						var caret = $(this).get(0).selectionStart;        				
        				
                		if(oldTekst.length != 8)
							text = $(this).val();          				
        				
        				hour = text.substring(0,2);
        				minute = text.substring(3,5);  
        				second = text.substring(6,8);    				
        										
        				//kursor unutar sata
						if(caret == 0)
						{
        					hour = text.substring(1,2);					
						}  						     				
						if(caret == 1)
						{
        					hour = text.substring(0,1);					
						} 

						//kursor unutar minute
						if ((caret == 3) || (caret == 2))
						{
        					minute = text.substring(4,5);					
						}         				
						if(caret == 4)
						{
        					minute = text.substring(3,4);					
						}	
						
					    //kursor unutar sekunde
					    if ((caret == 6) || (caret == 5))
						{
        					second = text.substring(7,10);					
						} 						
						if(caret == 7)
						{
        					second = text.substring(6,7) +  text.substring(8,10);					
						}					
					
       					var newtext = hour + ":" + minute + ":" + second;
       				
       					$(this).val(newtext);	
       					$(this).data("konto_text", newtext);
       				       				
       					$(this).get(0).setSelectionRange(caret, caret);
                   		$(this).data("shouldSelect", false);
               		} //kraj od allowed chars	
				});
				
			//override za kontrolu keydowna na buttonu
			//Fix za disable buttone
			root.find("button")
				.keydown(function(e) {
					var code = e.charCode || e.keyCode;
					var el = $(this);

		            if ((code == 13) || (code == 32)){ 
       					if(el.hasClass("disabled")) {
       						e.preventDefault();	
       					}
		            } 					
				});	
            	                      
            that.initFloatInputs(root);
            that.initIntInputs(root);
            that.createSifarnike(root);
            that.createCheckboxes(root);
            that.createExtendedCheckboxes(root);
			that.createComboboxes(root);
			that.createExtendedRadios(root);
            that.initForme(root);         
        },
        /**
         * Overrideanje entera - simulira se tab.
         * U event.data.focusable očekuje popis fokusabilnih elemenata.
         * */
        _kontoEnterFocusNext: function enterFocusNext(event) {
            var code = event.charCode || event.keyCode;
			var el = $(this);
			
            if (isset(event.target.type) && (event.target.type.toLowerCase() === "textarea"))
                return;  
                        	
            if (((code == 13)  || (code == 32)) && ((el.hasClass("btn-submit")) || (el.hasClass("btn-odustani"))) && (!el.hasClass("disabled"))) 
            	return;         	

            if ((code == 13) || (code == 9)) {   
                var self = $(this)
                  , root = event.data.root
                  , focusable
                  , next
                 ;

                /**
                 * Focusable se mijenja dinamički (dodavanjem novih elemenata, npr. unos posla - potposlovi se konstantno dodaju).
                 * Posljedično, ne mogu ovo cacheirati.
                 */
                focusable = root.find('input,a,select,button,textarea,span.konto-dropdownlist')
                    .filter(':visible')
                    .filter(':not(:disabled)')
                    .filter(':not([readonly])')
                    .filter(':not(.select-readonly)')
                    .filter(":not(.skipEnterTab)")
                    .filter(':not(.konto-readonly)')
                    .filter(':not(button.k-input-button)');
                
                if(event.shiftKey && code == 9) { 
 					 next = focusable.eq(focusable.index(this)-1);
				}else{
					next = focusable.eq(focusable.index(this)+1);	
				}
                
                if (next.length === 0) {
                    if (focusable.length === 0)
                        return false;
                    next = focusable.eq(0);
                }
                
                /**
                 * Fix za elemente kao npr. tabovi. Takvi elementi mogu biti različiti, pa ne mogu
                 * odmah znati koji su sve tipovi i klase i ne mogu ih pobrojati prilikom traženja 
                 * focusable.
                 * Ovo je hack kojim postavljam našu navigaciju s enterom na svaki element koji 
                 * nije inicijalno postavljen.
                 * 
                 * Potencijalni problem:
                 * što ako već imaju implementirano nekakvo ponašanje na enter?
                 */
                if (next.data("hasKontoEnterNavigation") !== true) {
                    next.keydown({ root: event.data.root }, enterFocusNext).data("hasKontoEnterNavigation", true);  
                }
                
                if (el.hasClass("kontoEnterFocusStop")){
                    el.blur();
                }
                else{
                    next.focus().select();
                }                    
                
                return false;
                
                /*
                if (next.length) {
                    
                }
                else if (focusable.length > 0) {
                    // Da, moglo bi biti readonly, disabled
                    focusable.eq(0).focus().select();
                }
                return false;
                */
            }
        },
        _popuniPolje: function(field, value){
            if(value == undefined)
                return false;
            
            var popuni = true;
            var valueAsString = String(value);

            if(this._provjeriValue){                          
                var parField = field.parent();            
                dataValue = field.data("value");
                fieldValue = field.val();

                // ne postavljamo polja koja imaju i imali su praznu vrijednost
                var sviPrazni = ((dataValue == null) && (fieldValue == "") && (valueAsString == ""))?true:false;
                var popuni = !sviPrazni;

                if(popuni){
                    // provjera šifarnika
                    if(parField.hasClass("sifarnik-group")){
                        if(valueAsString == "0")
                            valueAsString = "";
                        if(fieldValue == "0")
                            fieldValue = "";

                        popuni = (valueAsString != dataValue);   
                        popuni = popuni || (fieldValue == valueAsString) || ((fieldValue == "") && (valueAsString != "")); // ako u šifarniku piše samo šifra ili je prazan popuni

                        // popravak za odabir na ?  
                        if(!popuni){
                            var newValue = '';
                            if(valueAsString.trim() !== ""){
                                if(valueAsString.indexOf(" -") !== -1){
                                    newValue = valueAsString.substring(0, valueAsString.indexOf(" -")).trimEnd();
                                }
                                else{
                                    if(valueAsString.trim().indexOf(" ") !== -1){
                                        newValue = valueAsString.trim().substring(0, valueAsString.indexOf(" ")).trimEnd();
                                    }
                                    else{
                                        newValue = valueAsString;
                                    }
                                }  
                                popuni = (valueAsString != newValue);                                  
                            }
                            if(!popuni){
                                if(fieldValue.trim() !== ""){
                                    if(fieldValue.indexOf(" -") !== -1){
                                        newValue = fieldValue.substring(0, fieldValue.indexOf(" -")).trimEnd();  
                                    }
                                    else{
                                        if(fieldValue.trim().indexOf(" ") !== -1){
                                            newValue = fieldValue.trim().substring(0, fieldValue.indexOf(" ")).trimEnd();   
                                        }
                                        else{
                                            newValue = fieldValue;  
                                        }
                                    }
                                    popuni = (valueAsString != newValue);  
                                }
                            }
                        }
                        
                        // ne postavljamo za prazna polja
                        popuni = popuni && !((dataValue == null) && (valueAsString == ''));      
                    }
                    else{
                        // ostala polja
                        popuni = (fieldValue != valueAsString);
                    }
                }
            }                    
            return popuni;           
        },
        _overrideEnterBehaviour: function (root) {
            var el = root || this.root;                            
                
           	$(document).find("input.konto-input-date-separate, input.konto-input-time-separate, input.konto-input-time-ss-separate").keydown({ root: this.root }, this._kontoEnterFocusNext)
                .data("hasKontoEnterNavigation", true);

            el.find("input").keydown({ root: this.root }, this._kontoEnterFocusNext)
        		.data("hasKontoEnterNavigation", true); 	               
        },
        _overrideBackspaceBehaviour: function() {
            // TODO: više puta se izvodi...
            $(document).unbind("keydown").bind("keydown", function (event) {
                var doPrevent = false;
                // Backspace znak === 8
                if (event.keyCode === 8) {
                    var d = event.srcElement || event.target;
                    if ((d.tagName.toUpperCase() === 'INPUT' && (d.type.toUpperCase() === 'TEXT' || 
                            d.type.toUpperCase() === 'PASSWORD' || d.type.toUpperCase() === 'FILE')) || 
                            d.tagName.toUpperCase() === 'TEXTAREA') {
                        doPrevent = d.readOnly || d.disabled;
                    }
                    else {
                        doPrevent = true;
                    }
                }

                if (doPrevent) {
                    event.preventDefault();
                }
            });
        },
        /**
         * Metoda koja se može overrideati, ali se obavezno mora pozvati _remove metoda
         */
        remove: destroy,
        /**
         * Kreira AJAX queue, može se overrideati.
         */
       	createAjaxQueue: function() {
       		var that = this;
	       	return konto.ajaxQueue.$new({
	        	allowDuplicateReqs: false,
	        	queueDone: that.queueDone.bind(that)
	        });
        },
        /**
         * Ready funkcija u kojoj templateovi mogu registrirati svoje funkcije.
         */ 
        ready: function (func) {               		        	
            if (typeof func === "undefined") {   
            	if (this._ajaxAsync && !this._ajaxQueue.isEmpty() && this._readyCanExecute === false) {
            		/**
            		 * U slučaju ASYNC AJAX poziva u šifarnicima potrebno je da template pozove ready, 
            		 * ali i da AJAX queue kad je gotov pozove ready.
            		 * 
            		 * Prvi koji ulazi ovdje, postavlja flag _readyCanExecute i izlazi.
            		 * Drugi koji ulazi neće ući ovdje jer će _readyCanExecute biti true.
            		 */
            		this._readyCanExecute = true;
            		return;
            	}
            
            	this.sel(".konto-form-btns").removeClass("hide"); //tek kad je sve učitano omogućujemo unos.           	
            	
            	$(document.body).removeClass("nonClickable");  //tek kad je sve učitano omogućujemo i klikanje

				this.setElementsBeforeReady();
				
                $.each(this._readyFuncArray, function (index, item) {
                    item();
                }); 
                  
                this.setElementsOnReady(); 		                    		              		 
                this._readyExecuted = true;                               
            }
            else if (typeof func === "function") {
                if (this._readyExecuted)
                    func();
                else
                    this._readyFuncArray.push(func);
            }
            else {
                // krivi parametar
            }
        },
        setFirstVisibleTabSheetActive: function(navTabSelektor){
        	if (navTabSelektor == undefined){
        		liNavTab = $('.nav.nav-tabs');	
        	}else{
        		liNavTab = $(navTabSelektor);	
        	}	        			
			//ako imamo više poslanih / nađenih tabova
			$.each( liNavTab, function( key, value ) {
  				var liNav = $(value).find('a').filter(':visible')
                    .filter(':not(:disabled)')
                    .filter(':not([readonly])')
                    .filter(':not(.select-readonly)')
                    .filter(':not(.konto-readonly)').first().click();
                
			});
        },   
        /**
         *  Postavljanje extended checkboxova i radio butona prije izvršavanja ready
         */     
        setElementsBeforeReady: function() {
        	/**
        	 * Postavlja vrijednost za konto-radio-extended
        	 */
	     	this.sel(".konto-radio-extended")
	     		.each(function(){
					$(this).kontoRadioExtendedInit();
	    		});	 		    		        	           
        	
			/**
			 * Postavljanje inicijalnih vrijednosti konto extended checkboxova
			 * Korekcija za reverse funkcionalnost
			 */				
			this.sel(".konto-checkbox-extended")
				.each(function(){
		        	$(this).kontoCheckboxExtendedInit();			        									
				});	         	        	
        },         
        /** 
         *  Postavljanje raznih elemenata na ready funkciji
         */
        setElementsOnReady: function() {
         	/**
         	 * Postavljanje css klase za radio butone
         	 * izvršava se kod loada forme
         	 * ukoliko nije uski css makni klasu za poravnavanje labele
         	 */
        	this.sel(".konto-radio")
        		.each(function(){
        			$(this).addClass("radioButton");
        			
        			if(!($.styleSheetExist('.uskiCSS'))){
        				$(this).find('*').removeClass('radioInline');
        			}
        		});  
        	
        	//micanje sata sa separate time djela (gdje je to potrebno)	
            $("input.konto-hide-time-picker")
         		.each(function() {
					$(this).siblings().remove()         				       			
         		}); 
         		
            $("input.konto-hide-time-ss-picker")
         		.each(function() {
					$(this).siblings().remove()         				       			
         		});       	        	  
				
        	/**
         	* Postavljanje početne vrijednosti iz vezane hidden datetime varijable u polja za odvojen unos datuma i vremena
         	* klasa "konto-datetime-separate"
         	* data("hasKontoEnterNavigation", true) - defaulna opcija je enter = tab 
         	* moguće zabraniti promjenom navedene varijable
         	*/              
         	$("input.konto-datetime-separate")
         		.each(function() {
					$(this).kontoDateTimeSeparateInit();          				       			
         		}); 

           /**
        	 * Postavljanje readonly za konto-readonly 
         	 *          	 
        	 */
     		this.sel(".konto-readonly")
				.each(function(){												
					$(this).setKontoReadonly();																		
				});  
        },
        
        
        /**
         * Loaded funkcija u kojoj templateovi mogu obaviti neku inicijalizaciju.
         */ 
        loaded: function (func) {       	
            if (typeof func === "undefined") {
                $.each(this._loadedFuncArray, function (index, item) {
                    item();
                });
                this._loadedExecuted = true;
            }
            else if (typeof func === "function") {
                if (this._loadedExecuted)
                    func();
                else
                    this._loadedFuncArray.push(func);
            }
            else {
                // Krivi parametar
            }
        },
        /**
         * Before loaded funkcija izvodi se neposredno nakon učitavanja forme.
         * Primjer korištenja: ispis forma, brisanje nepotrebnih inputa 
         * (npr. zbog toga jer idu na Datasnap po podatke u tablice kojih nema - RIZNICA)
         */
        beforeLoaded: function (func) {
            if (typeof func === "undefined") {
                $.each(this._beforeLoadedFuncArray, function (index, item) {
                    item();
                });
                this._beforeLoadedExecuted = true;
            }
            else if (typeof func === "function") {
                if (this._beforeLoadedExecuted)
                    func();  
                else
                    this._beforeLoadedFuncArray.push(func);
            }
            else {
                // Krivi parametar.
            }
        },
		/**
		 * Koristi se kod async AJAX requestova. Queue šalje poruku kad je završio s učitavanjem.
		 */
		queueDone: function() {
			this.ready();
		},
		
        /**
         * Dohvacanje funkcija za submit evente (before, success, after) - function pimp :D
         */
        fetchSubmitEvents: function (type, data) {
            if (typeof type != 'undefined' && typeof this._submitEventsFuncArray[type] != 'undefined') 
                $.each(this._submitEventsFuncArray[type], function (index, funkcija) {
                    funkcija(data);
                }); 
                
        	/**
         	* Postavljanje vrijednosti u vezanu hidden datetime varijablu iz odvojenih polja datuma i vremena prilikom submita
         	* klasa "konto-datetime-separate"
         	*/                  
         	$("input.konto-datetime-separate")
         		.each(function() {
					$(this).kontoDateTimeSeparateSubmit();
         		});                    
        },
                
        /**
         * Postavljanje funkcija za submit evente - function hooker :D
         */
        hookSubmitEvents: function (type, func) {
            if (typeof func === "function" && typeof type != 'undefined') {
                if (typeof this._submitEventsFuncArray[type] === 'undefined')
                    this._submitEventsFuncArray[type] = [];
                     
                this._submitEventsFuncArray[type].push(func);
            }
            
        },
        
        /**
         * Vraća naziv eventa u obliku eventName.{unique}
         */
        getEventName: function (eventName) {
            return eventName + "." + this.unique;
        },

        /**
         * Funkcija koja postavlja vrijednost input elementa.
         * 
         * Za date i datetime se koristi JavaScript date objekt.
         * Posebna obrada se koristi i za floatove, dropdown, checkbox 
         */
        setElementValue: function (field, value) {
            if (!field)
                return;
            
            if (typeof field === 'string') {
                var field = this.sel(field);
                if (!field)
                    return;
            }
        
        	if (field.inputType == "radio") {
                if (typeof field[value] !== "undefined")
                    field[value].attr("checked", "checked");
            }   
            else { 
                if (field.hasClass("konto-input-date")) {
					var val = KUtils.OdreziTimeZone(value);
                    var d = new Date(val);    
                    field.data("kendoDatePicker").value(d);
                }
                else if (field.hasClass("konto-input-year")) {
					var val = KUtils.OdreziTimeZone(value);
                    var d = new Date(val);    
                    field.data("kendoDatePicker").value(d);                   
                }   
                else if (field.hasClass("konto-input-datetime")) {
                    var val = KUtils.OdreziTimeZone(value);
                    var dt = new Date(val);
                    
                    //iznimka za potposlove
                    if (!KUtils.isValidDate(dt))
                        dt = KUtils.parseDateTime(value);
                    
                    field.data("kendoDateTimePicker").value(dt);                   
                }
                else if (field.hasClass("konto-input-datetime-ss")) {
                    var val = KUtils.OdreziTimeZone(value);
                    var dt = new Date(val);
                    
                    //iznimka za potposlove
                    if (!KUtils.isValidDate(dt))
                        dt = KUtils.parseDateTime(value);
                    
                    field.data("kendoDateTimePicker").value(dt);
                    
                }   
                else if (field.hasClass("konto-input-time")) {
                    var val = KUtils.OdreziTimeZone(value);
                    var dt = new Date(val);
                    
                    //iznimka za potposlove
                    if (!KUtils.isValidDate(dt))
                        dt = KUtils.parseTime(value);
                    
                    field.data("kendoTimePicker").value(dt);
                    
                }      
                else if (field.hasClass("konto-input-time-ss")) {
                    var val = KUtils.OdreziTimeZone(value);
                    var dt = new Date(val);
                    
                    //iznimka za potposlove
                    if (!KUtils.isValidDate(dt))
                        dt = KUtils.parseTime(value, true);
                    
                    field.data("kendoTimePicker").value(dt);
                    
                }                                          
                else if (field.hasClass("konto-dropdownlist")) {
                    field.data("kendoDropDownList").value(value);
                }
                else if (field.hasClass("konto-combobox") || (field.data('role') == 'combobox')) {
                    field.data("kendoComboBox").value(value);
                }
                else if (field.hasClass("float-value")) {
                    var decimals = field.data("decimals") || 2;
                    field.val(KUtils.formatFloat(value, decimals));
                }
                else if (field.hasClass("int-value")) {
                	if (!field.hasClass("no-format"))
                    	field.val(KUtils.formatInt(value));
                    else
                    	field.val(value);
                }
                else if (field.attr("type") == "checkbox") {
					field.prop("checked", value); 
                }
                else {
                    if(this._popuniPolje(field, value)){
                        // U ovom trenutku postoji mogućnost da u value već imamo nešto (u slučaju šifarnika i u data("value"). Potrebno je onda prvo upisati null u data("value")
                        // jer val(value) neće poništiti prijašnju vrijednost.
                        // Kad korisnik to radi je sve ok jer se na keypress obriše data("value").
                        field.data("value", null);

                        if(typeof value === "string" || value instanceof String){
                            value = KUtils.htmlTagCharsDecode(value);	
                        }
                        field.val(value);
                        
                        var _krbex = field.data("krbex");
                        if(_krbex){
                            if(field.val() == "true") {
                                field.val("1");
                            }
                            else{
                                field.val("0");
                            }
                        }     
                    }            
                }
            }
        },
        
        /**
         * Funkcija koja dohvaca vrijednost (bez obzira na tip kendo elementa)
         */
        getElementValue: function (field) {
            if (!field)
                return;

            if (typeof field === 'string') {
                var field = this.sel(field);
                if (!field)
                    return;
            }
                                        
            if (field.inputType == "radio") {
                if (typeof field[value] !== "undefined")
                    return field[value].attr("checked");
            } else { 
                if (field.hasClass("konto-input-date")) {
                	return field.data("kendoDatePicker").value();
                }
                else if (field.hasClass("konto-input-year")) {                    
                 	return field.data("kendoDatePicker").value();                    
                }                
                else if (field.hasClass("konto-input-datetime")) { 
                 	return field.data("kendoDateTimePicker").value();                    
                }
                else if (field.hasClass("konto-input-datetime-ss")) {                    
                 	return field.data("kendoDateTimePicker").value();                    
                }            
                else if (field.hasClass("konto-input-time")) {                    
                 	return field.data("kendoTimePicker").value();                    
                }   
                else if (field.hasClass("konto-input-time-ss")) {                    
                 	return field.data("kendoTimePicker").value();                    
                }                                   
                else if (field.hasClass("konto-dropdownlist")) {
                    return field.data("kendoDropDownList").value();
                }
                else if (field.hasClass("konto-combobox")) {
                    return field.data("kendoComboBox").value();
                }
                else if (field.hasClass("float-value")) {
                    //var decimals = field.data("decimals") || 2; //ovdje ne treba decimals jer vrati vrijednost koja je unutra
                    return field.val(); //KUtils.formatFloat(value, decimals));
                }
                else if (field.hasClass("int-value")) {
                    return field.val();
                }
                else if (field.attr("type") == "checkbox") {
                	return field.attr("checked");
                }
                else if (field.parent().hasClass("sifarnik-group")) {
                    return field.sifVal();
                }
                else {
                    return field.val();
                }
            }
        },        
        
        
        /**
         * Briše vrijednost elementa.
         */
        clearElementValue: function (field) {
            if (!field)
                return;
            
            if (field.inputType == "radio") {
                $.each(field, function (key, value) {
                    if (value instanceof jQuery) 
                        value.attr("checked", false);
                });
            }
            else { 
                if (field.hasClass("konto-input-date")) {   
                    field.data("kendoDatePicker").value(null);
                }
                else if (field.hasClass("konto-input-year")) {
                    field.data("kendoDatePicker").value(null);
                }                
                else if (field.hasClass("konto-input-datetime")) {
                    field.data("kendoDateTimePicker").value(null);
                }
                else if (field.hasClass("konto-input-datetime-ss")) {
                    field.data("kendoDateTimePicker").value(null);
                }     
                else if (field.hasClass("konto-input-time")) {
                    field.data("kendoTimePicker").value(null);
                }
                else if (field.hasClass("konto-input-time-ss")) {
                    field.data("kendoTimePicker").value(null);
                }                                           
                else if (field.hasClass("konto-dropdownlist")) {
                    field.data("kendoDropDownList").value(null);
                }
                else if (field.hasClass("float-value")) {
                    var decimals = field.data("decimals") || 2;
                    field.val(KUtils.formatFloat(0, decimals));
                }
                else if (field.hasClass("konto-combobox")) {
                    field.data("kendoComboBox").value(null);
                }
                else if (field.attr("type") == "checkbox") {
                    field.attr("checked", null);
                }
                else {
                    // U ovom trenutku postoji mogućnost da u value već imamo nešto (u slučaju šifarnika i u data("value"). Potrebno je onda prvo upisati null u data("value")
                    // jer val(value) neće poništiti prijašnju vrijednost.
                    // Kad korisnik to radi je sve ok jer se na keypress obriše data("value").
                    field.data("value", null);
                    field.val("");
                }
            }
        },        
        
        /**
         * Funkcija inicijalizira dropdown (combobox).
         * U this očekuje HTML element.
         *
         * Opcije dropdown-a:
         *  - dataSource: link gdje se nalaze podaci za dropdown
         *  - textField: vrijednost koja se prikazuje u dropdown-u za neki item
         *      default: NAZIV
         *  - valueField: PK vrijednosti iz dropdown-a
         *  - optionLabel: labela koja se prikazuje kad ništa nije zadano
         *      default: prazan string
         *  - height: visina polja za odabir. 
         *		default 200px (to je generalno za kendo). Ako želimo da se sve vidi treba postaviti na "auto"		
         */
        initDropDown: function () {
            var cmb = $(this); 
            var dataSource = cmb.data("dataSource");
            var optionLabel = cmb.data("optionLabel") || "";
            var dHeight = cmb.data("height") || "200";
            if (dataSource) {
                textField = cmb.data("textField") || "NAZIV";
                valueField = cmb.data("valueField");
                var ds = new kendo.data.DataSource({
                    serverPaging: true,
                    serverFiltering: true,
                    transport: {
                        read: {
                            url: kontorouter.getModulPath(dataSource),
                            dataType: "json",
                            data: {
                                reqtype: "kendogrid"
                            }
                        }
                    },
                    schema: {
                        total: function (response) {
                            if (response == null)
                                return 0;
                            if (typeof response.total !== "undefined")
                                return response.total;
                            else if ($.isArray(response))
                                return response.length;
                            else
                                return 0;
                        }, 
                        data: function (response) {
                            if (response == null)
                                return [];
                            
                            var data = response.rows;
                            if (data == null) {
                                if ($.isArray(response)) {
                                    return response;
                                }
                                return [];
                            }
                            
                            var keys = [], k = 0;
                            for (var key in data) {
                                keys[k++] = key;
                            }
                            if (keys.length == 0)
                                return null;
                            
                            var result = [];
                            for (var i = 0; i < data[keys[0]].length; ++i) {
                                var item = {};
                                for (var j = 0; j < keys.length; ++j) {
                                    item[keys[j]] = data[keys[j]][i];
                                }
                                result[i] = item;       
                            }   
                            return result;
                        }
                    },
                    pageSize: 100
                });
                cmb.kendoDropDownList({
                    dataSource: ds,
                    dataTextField: textField,
                    dataValueField: valueField,
                    dataBound: function (e) {
                        this.trigger("change");
                    },
                    optionLabel: optionLabel,
                    height: dHeight
                });
            }
            else {
                cmb.kendoDropDownList({height: dHeight});
            }
        },
        /**
         * Funkcija inicijalizira konto-checkbox komponente.
         * Napravljena je zato da se labela i checkbox postave uvijek na isti način.
         * 
         * Zbog velikog broja parametara pitanje je da li je potrebna i ima li smisla.
         */
        createCheckboxes: function (root) {
            // Kreiram checkboxove
            root.find(".konto-checkbox").each(function () {
				$(this).kontoCheckboxCreate();
            });
        },
        
		/**
		 * Nova klasa za konto-checkbox nazvati cemo ju konto-checkbox-extended
		 */
     	createExtendedCheckboxes: function(root) {			
			root.find(".konto-checkbox-extended")
				.each(function(){
					$(this).kontoCheckboxExtendedCreate();								
				})
			    .keydown(function(e) {
                    if ($(this).isKontoReadonly()){
                    	e.preventDefault();
                    	return; 
                	 }    
                });
        },        
        
		/**
		 * Nova klasa za konto-radio nazvati cemo ju konto-radio-extended
		 */
		        
        createExtendedRadios: function (root) {
			root.find(".konto-radio-extended")
				.each(function(){
					$(this).kontoRadioExtendedCreate();		
				});        	        	
        },      
		
        createComboboxes: function (root) {
            // Za sve comboboxeve kreira evente
            var that = this;
            root.find(".combobox-group").each(function () {
                that.createCombobox(this, root);
            });
        },
        /**
         * Funkcija koja iz inputa kreira comboboxove.
         *
         * Parametri za comboboxove:
         * - callback: root ime za callbackove
         *      npr. za onPartner će se pretpostaviti da postoje eventi:
         *          onPartnerSelect
         *          onPartnerChange
         *		ako nije definiran ovaj parametar, za root ime callbackove će se uzeti 
         * 		naziv comboboxa, npr: onCmbPartnerSelect;
         * 			- ako se eksplicitno postavi "false" vrijednost parametra, neće se definirati callbackovi
         * - PK-field: naziv primarnog kljuca (koristi se ako value-field nije definiran)
         * - datasource: naziv smarty varijable sa listom vrijednosti
         * - template: format izgleda comboboxa
         * 
         * Opcionalni parametri
         * - text-field: naziv tekstualnog polja koji će se prikazivati u comboboxu
         * - value-field: naziv polja koji se upisuje kao selektirana vrijednost comboboxa (primarni ključ)
         * - filter: algoritam filtriranja rezultata (defaultno: contains)
         * - autobind: način povezivanja s podacima, odmah ili tek na prvom kliku (defaultno: false)
         * - height: visina padajućeg izbornika (defaultno: 370)
         *
         * Opis evenata koje sifarnik zove:
         *  onSelect - poziva se nakon nakon selektiranja stavke comboboxa
         *  onChange - poziva se nakon nakon promjene vrijednosti comboxa
         *  onClose - poziva se nakon zatvaranja comboboxa (padajućeg izbornika)
         *  onOpen - poziva se nakon otvaranja comboboxa (padajućeg izbornika)
         *  onDataBound - poziva se nakon povezivanja dataSourcea sa elementom
         *
         */
        
        createCombobox: function (group, root) {
            var that = this;

            group = $(group);
            
            var cmbName = group.data("element-name");  
            //var datasource = group.data("datasource") || (cmbName+'List'); //TODO: mozda kasnije implementirati ako se ukaze potreba
            var textField = group.data("text-field") || "NAZIV";
            var valueField = group.data("value-field") || group.data("pk-field") ;
            var template = group.data("template") || '#: data.'+textField+' #';
            var callbackName = group.data("callback");
            var inputReadonly = group.data("input-readonly");
            
            if (callbackName !== 'false') //znaci ako bas eksluzivno ne zelimo nikakav callback
	            if (!isset(callbackName) || callbackName == '')
	            	callbackName = 'on'+cmbName.capitalizeFirstLetter(); //ako nije definiran callback, definiramo neko genericko ime callbacka prema nazivu comboboxa
            
            var filter = group.data("filter") || "contains";
            var autobind = (group.data("autobind") === 'true');
            var height = group.data("height") || 370;
            var clearButton = group.data("clearButton"); 
            if (clearButton == undefined){
				clearButton = true;	
			}

            var options = {
	            filter: filter,
	            dataTextField: textField,
	            dataValueField: valueField,
	            template: template,
	            dataSource: {},
	            height: height,
	            autoBind: autobind,
	            clearButton: clearButton,
	            
	            //eventi
	            change: function(e) {
	                if (callbackName !== 'false' && that[callbackName + "Change"]) {
	                    return that[callbackName + "Change"].call(e);
	                }           
	            },
	            open: function(e) {
	                if (callbackName !== 'false' && that[callbackName + "Open"]) {
	                    return that[callbackName + "Open"].call(e);
	                }   
	            },
	            close: function(e) {
	                if (callbackName !== 'false' && that[callbackName + "Close"]) {
	                    return that[callbackName + "Close"].call(e);
	                }   
	            },
	            dataBound: function(e) {
	                if (callbackName !== 'false' && that[callbackName + "DataBound"]) {
	                    return that[callbackName + "Change"].call(e);
	                }   
	            },
				//cascade se okine prije change ali i kad se programski postavi vrijednost (kod popunjavanja kućica)
				cascade: function(e) {
	                if (callbackName !== 'false' && that[callbackName + "Cascade"]) {
	                    return that[callbackName + "Cascade"].call(e);
	                }   
	            },
	            select: function(e) {
	                if (callbackName !== 'false' && that[callbackName + "Select"]) {
	                    return that[callbackName + "Select"].call(e);
	                }   
	            }
            };

            //inicijalizacija praznog comboboxa
			that[cmbName] = group.find('input').kendoComboBox(options).data('kendoComboBox');

			if (inputReadonly){
				group.find('input.k-input-inner').prop("readonly", true);
			} 

        },
        
        createSifarnike: function (root) {
            // Za sve sifarnik buttone kreira evente
            var that = this;
            root.find(".sifarnik-group").each(function () {
                that.createSifarnik(this);
            });
        },
        /**
         * Funkcija koja iz inputa kreira šifarnik.
         *
         * Napomena 1: sifarnik-button nije potrebno dodati u template-u. Ako NE postoji
         * dodat će se u ovoj funkciji.
         *
         * Parametri za šifarnik:
         * - col-filter: po kojem se stupcu traži unutar šifarnika kad se ne upiše vrijednost
         *      default: NAZIV
         * - path: link do šifarnika
         * - pk-column: primary key
         * - callback: root ime za callbackove
         *      npr. za onPartner će se pretpostaviti da postoje eventi:
         *          onPartnerExit
         *          onPartnerClear
         *          onPartnerSifarnikLink
         *          onPartnerOdabir
         *          onPartnerMethod
         * - ds-method: metoda koja se zove u Datasnapu nakon što se upiše PK u input
         *          npr. u kućicu partnera upisan je 1 i krene se u drugu kućicu. Na blur
         *          event će se pozvati ova metoda 
         * - ds-method-param: parametri za gornju metodu
         * - ds-method-number: označava da li se prosljeđuje broj kao PK. Npr. za partnere je integer, za mjesta troška
         *      je string pa treba postaviti na false.
         *      default: true
         *
         * Opis evenata koje sifarnik zove:
         *  onSifarnikLink - služi za postavljanje putanje (linka) do šifarnika. Putanja se može promijeniti
         *      zbog npr. drugih inputa na formi i slično. Najčešće se ne mijenja sam šifarnik (tj.
         *      metoda unutar controllera), već se neki prosljeđuju drugačiji parametri ili filteri.
         *      NAPOMENA: ne poziva se ako postoji zadana fiksna putanja do šifarnika (parametar "path")
         *      NAPOMENA 2: vraćanjem NULL vrijednosti, prekida se poziv šifarnika.
         *  onExit - poziva se nakon poziva datasnap metode
         *  onClear - nakon izlaska iz elementa kad nismo zadali ništa ili smo zadali nešto za što se ne može ići
         *      provjeriti postoji li slog za tu vrijednost. Pr. string "KON" u partneru. Razlog je taj što je partner integer,
         *      mi smo zadali string.
         *      Razlika obzirom na desktop je da se ovdje ne poziva šifarnik na onExit eventu.
         *
         *  onOdabir - poziva se nakon selektiranja retka u šifarniku
         *  onMethod - poziva se u trenu kad sustav odluči da treba pozvati datasnap metodu (npr. PartnerById). 
         *      NAPOMENA: ne poziva se ako postoji ako je zadan ds-method parametar.
         *
         *  
         */
        createSifarnik: function (group) {
            var that = this;

            group = $(group);
            // Kreiram sifarnik button ak ne postoji.
            var btn = $(".sifarnik-button", group);
            if (btn.length == 0) {
				var upitnikBtn = $('<div class="input-group-append sifarnik-button"><span class="input-group-text">?</span></div>')
				group.append(upitnikBtn); 
                btn = $(upitnikBtn);
            }
            // Dodajem u slučaju šifarnika - da se spoji s "?" buttonom.
            $("input", group).addClass("form-control");
            var dataElementClass = group.data("col-class") || group.data("col-id");
            var dataElement = null;
            if (dataElementClass) 
                dataElement = $("." + dataElementClass);
            else 
                dataElement = $("input", group);
            var searchColumn = group.data("col-filter") || "NAZIV";      
            var searchColumnReset = (group.data("reset-col-filter") === true);                        
            var sifarnikPath = group.data("path");
            if (sifarnikPath)
                sifarnikPath = kontorouter.getModulPath(sifarnikPath);
            var pkColumn = group.data("pk-column") || "";
            var callbackName = group.data("callback");
            var dsMethod = group.data("ds-method");
            var dsMethodParam = group.data("ds-method-param");
            var dsMethodNumberCheck = !(group.data("ds-method-number") === false);
            var filterDisabled = (group.data("filter-disabled") === true);  
            var postParam = group.data("post-param");                      
            var dataOldValue = null;
            
            // O kojim šifarnicima ovisi vrijednost. Bitno zbog request queuea.
            var dependencies = (group.data("dependencies") || "");
            if (dependencies.length === 0)
            	dependencies = [];
            else 
            	dependencies = dependencies.split("|");
            	
            // Koji je moj naziv koji mogu koristiti druge komponente u data-dependencies atributu.
            var dependName = dataElement.attr("name");
                       
			var validateExists = true;				
			if (typeof group.data('validate-exists') != 'undefined') {
				validateExists = group.data('validate-exists');			
			}	            
            dataElement.data("validateExists", validateExists);
            
            /**
             * Event funkcije.
             */
            function _sifarnikDefaultOdabirCB(data) {
            	csd ('default odabir cb');
            	
            	//ako nije definiran 'text-field' uzima se 'NAZIV'
            	var textField = group.data("text-field") || 'NAZIV';
            	
            	//ako nije definiran 'value-field' uzima se primarni kljuc
            	var valueField = group.data("value-field") || group.data("pk-column");
            	
	            if (data && valueField) {//u slucaju da je data prazan ili valueField nije definiran
	            	if (isset(data[valueField])) {
	            		var naslovi = textField.split(',');
	            		if (naslovi.length > 1) {
	            			var naslovi_svi = '';
	            			$.each(naslovi, function(key, naslov) {
	            				naslovi_svi += data[naslov]+' ';
	            			});
	            			naslovi = naslovi_svi.slice(0, -1);
	            		} else
	            			naslovi = data[textField];
	            		
						dataElement.val(data[valueField]+ ' - ' + naslovi);
					} else {
						cs ('nije pronadjena vrijednost za '+valueField);
		            	cs (data);
					}
	            } else {
	                dataElement.val("");
	            }
            
            }
            function _sifarnikDefaultExitCB(data) {
            	csd ('default exit cb');
            	_sifarnikDefaultOdabirCB(data);
            }
            function _sifarnikDefaultClearCB() { 
            	csd ('default clear cb');         	
            }
            function _sifarnikDefaultMethodCB() {
            	csd ('default method cb'); 
            }
            function _sifarnikDefaultSifarnikLinkCB() {
            	csd ('default sifarnikLink cb'); 
            }
            function _sifarnikDefaultFilterCB() {
            	csd ('default filter cb'); 
            }
            
            function doOnSifarnikLink() {
                if (that[callbackName + "SifarnikLink"]) 
                    return that[callbackName + "SifarnikLink"].call(dataElement);
                else
                	return _sifarnikDefaultSifarnikLinkCB();       
            }

            function doOnOdabir(data) {
                if (data) {
                    var frm_grp = dataElement.closest(".form-group");
                    frm_grp.removeClass("has-error");
                    frm_grp.removeClass("is-invalid");
                    dataElement.removeClass("border-danger");
                    frm_grp.find(".input-group-text").removeClass("border-danger");
                    
                    if (pkColumn && data[pkColumn]) {
                        dataElement.data("value", data[pkColumn]);
                        dataOldValue = data[pkColumn];
                    }
                }
                
                if (that[callbackName + "Odabir"])
                    return that[callbackName + "Odabir"].call(dataElement, data);
                else
                	return _sifarnikDefaultOdabirCB(data);
            }

            function doOnMethod() {
                if (that[callbackName + "Method"]) 
                    that[callbackName + "Method"].call(dataElement);
                else
               		return _sifarnikDefaultMethodCB();
            }

            function doOnFail(error, textStatus, jqXHR, logicalError) {
                if (that[callbackName + "Fail"])
                    that[callbackName + "Fail"].call(dataElement, error, textStatus, jqXHR, logicalError);

                $.dsQuery.handleAjaxError(error, textStatus, jqXHR);
            }

            function doOnExit(data) {
            	var frm_grp = dataElement.closest(".form-group");
                if (data) {
                    frm_grp.removeClass("has-error");
                    frm_grp.removeClass("is-invalid");
                    dataElement.removeClass("border-danger");
                    frm_grp.find(".input-group-text").removeClass("border-danger"); 
                                        
                    if (pkColumn && data[pkColumn]) {
                        dataElement.data("value", data[pkColumn]);
                    	dataOldValue = data[pkColumn];
                    }
                    
                } else if (dataElement.val()) {
                	if(dataElement.data("validateExists")){                		              		
	                    frm_grp.addClass("has-error");                    
	                    frm_grp.addClass("is-invalid"); 
	                    dataElement.addClass("border-danger");
	                    frm_grp.find(".input-group-text").addClass("border-danger"); 	                    
	                    
	                    // Ovdje dodati odabir iz šifarnika
	                    //dataElement.val("");
	                    //dataElement.data("value", null);
	                    var dsMethodNumberCheck_temp = dsMethodNumberCheck;
	                    dsMethodNumberCheck = false;
	                    searchColumn = "NAZIV";  
	                    dataElement.focus();                  
	                    btn.click();
	                    dsMethodNumberCheck = dsMethodNumberCheck_temp;
                   }
                }
                
                if (that[callbackName + "Exit"]) {
                	return that[callbackName + "Exit"].call(dataElement, data);
                }                    
               	else {
               		return _sifarnikDefaultExitCB(data);	
               	}             		               		              	
            }

            function doOnClear() {
                dataElement.data("value", null);
                dataOldValue = null;
                dataElement.closest(".form-group").removeClass("has-error");
                if (dataElement.val()) {
                    dataElement.closest(".form-group").addClass("has-error");
                }
                if (that[callbackName + "Clear"]) 
                    return that[callbackName + "Clear"].call(dataElement);
                else
                	return _sifarnikDefaultClearCB();
            }
            
            function doOnFilter() {
                if (that[callbackName + "Filter"]) 
                    return that[callbackName + "Filter"].call(dataElement);
                else
                	return _sifarnikDefaultFilterCB();
                	
                return null;
            }
            
            function getSifarnikPath() {
                if (sifarnikPath)
                    return sifarnikPath;
                else {
                    p = doOnSifarnikLink(); 
                    if (p) {
                        p = kontorouter.getModulPath(p);
                        return p;
                    }
                }
                return null;
            }
            
            function shouldPreventFocusOut() {
                var elementValue = $.trim(dataElement.val());
                if (elementValue == "" || elementValue == "0")
                    return false;
                var value = dataElement.data("value") || dataElement.val();
                return !(!dsMethodNumberCheck || KUtils.isNumber(value));
            }
            
            /**
             * Koristi se za sve evente.
             */
            function preventLosingFocus(e) {
                if (e.type === "click" || e.type === "mousedown") {
                    if (e.target === dataElement.get(0)) {
                        return;
                    }
                }
                
                if (e.type === "keydown") {
                    if (!(e.keyCode === 13 || e.keyCode === 9)) {
                        return;
                    }
                }
                
                if ($(e.target).hasClass("btn-odustani")) 
                    return;
               
                if (shouldPreventFocusOut()) {
                    e.preventDefault();  //prevent default DOM action
                    e.stopImmediatePropagation();   //stop bubbling
                    e.stopPropagation();
                    
                    btn.click();
                }
            }
            
            /**
             * Sprječavanje izlaska iz inputa šifarnika kad nije upisana odgovarajuća vrijednost je
             * malo problematično.
             * 
             * Ono što treba spriječiti:
             *  1. odlazak u novo polje pritiskom na TAB - jednostavno na keydown eventu
             *  2. odlazak u novo polje pritiskom na ENTER - budući da mi enterom simuliramo tab
             *      event je već bindam prije nego dođemo do ovog dijela koda tako da se izvršava prvo focus
             *      u novi element i onda se poziva naš preventLosingFocus event.
             * 3. klik na neki drugi gumb unutar našeg prozora (npr. "?" od drugog šifarnika ili "Upiši" trebao
             *      bi biti disablean - isto kao i na desktopu)
             * 4. klik na "Odustani" trebao bi proći
             * 
             * Put prema rješenju:
             *  - event capturing - dohvaćanje evenata od roditelja prema djetetu
             *      Prilično dobro objašnjenje:
             *      http://javascript.info/tutorial/bubbling-and-capturing
             *  - naravno, ovo gore NE podržava IE <= 8, dok svi ostali podržavaju
             *      Rješenje u tom slučaju nije moguće jednostavno implementirati.
             *  - jQuery ne podržava event capturing jer ne podržava IE <= 8 
             *        
             */
            var mousedownEvent = "mousedown.sifarnik";
            var mousedownEventName = mousedownEvent + that.unique;
            var clickEvent = "click.sifarnik";
            var clickEventName = clickEvent + "." + that.unique;
            var keydownEvent = "keydown.sifarnik";
            var keydownEventName = keydownEvent + "." + that.unique;
            
            function removeFocusOutEvents() {
                if (document.addEventListener) {
                    document.removeEventListener("mousedown", preventLosingFocus, true);
                    document.removeEventListener("keydown", preventLosingFocus, true);
                    document.removeEventListener("click", preventLosingFocus, true);
                }
                else {
                    $(document).off(mousedownEvent);
                    $(document).off(clickEvent);
                    $(document).off(keydownEvent);
                }    
            }

            function addFocusInEvents() {
                removeFocusOutEvents();
                
                if (document.addEventListener) {
                    document.addEventListener("mousedown", preventLosingFocus, true);
                    document.addEventListener("keydown", preventLosingFocus, true);
                    document.addEventListener("click", preventLosingFocus, true);
                }
                else {
                    $(document).on(mousedownEventName, preventLosingFocus);
                    $(document).on(clickEventName, preventLosingFocus);
                    $(document).on(keydownEvent, preventLosingFocus );
                }    
            }            

            dataElement
                .focusin(function (e) {
                    addFocusInEvents();
                })
                .focusout(function (e) {
                    removeFocusOutEvents();  
                })
                /*
                .keydown(function (e) {
                    var code = e.keyCode || e.which;
                    if (code == 13 || code == 9) {
                        if (shouldPreventFocusOut())
                            e.preventDefault();
                    }  
                })
                */
               
                .keydown(function (e) {
                    if (dataElement.prop("readonly") || dataElement.prop("disabled") || $(this).hasClass("konto-readonly"))
                        return;                        
                        
                    /**
                     * Dozvoljavam brisanje.
                     */          
                    if (e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 46)
                    	return;
                                   	
                	//cs ('key: '+e.keyCode + ' printable: '+KUtils.isKeyCodePrintable(e.keyCode));
                	
                    /**
                     * Character dozvoljam. 
                     * Npr. označeno je "1 - Konto d.o.o. Požega" i želimo promijeniti partnera.
                     * Ne dozvoljavam strelice jer s njima mogu editirati.
                     */
                    if (KUtils.isKeyCodePrintable(e.keyCode)) 
                        return;
                        
                    if ($(this).data("value")) {
                        e.preventDefault();
                    }   
                })
                .keypress(function (e) {
                    if (dataElement.isKontoReadonly())
                        return;
                    var code = e.keyCode || e.which;
                    if (code == 13 || code == 9 || e.ctrlKey)
                        return;
                    if ($(this).data("value")) 
                        $(this).val("");
                    $(this).data("value", null);
                    dataOldValue = null;
                }) 
                .on('paste', function(e){
                	$(this).data("value", null);
                    dataOldValue = null;	
                })      
                /**
                * Safari popravak za ctrl-c
                */
                .on('copy', function (e) {         
					if(KUtils.isSafari())
					{					
  						//setTimeout(function () {					
  						//	alert(e.originalEvent.clipboardData);
  						//}, 200);											
					}                 	
                })
                .click(function () {            	
                    if ($(this).data("value")) {

                    	$(this).select();
                   		
                        // Chrome fix
                        $(this).mouseup(function () {
                            $(this).unbind("mouseup");
                            return false;
                        });
                    }
                }) 
                ;
            dataElement.data("sifarnikPokrenut", false);
            dataElement.data("value", null);
            
            btn
	            .click(function (e) {
                    if(searchColumnReset){
                        searchColumn = $(this).parent().data("col-filter");
                    }
                    
	            	if((dataElement.val() == "") && (dataElement.data("value") != '')){            		
	            		dataElement.data("value", null); // doOnClear();
	            	}
	            	
	                if (dataElement.data("sifarnikPokrenut") !== false) {
	                    return;
	                }
	                
	                if (dataElement.prop("readonly") || dataElement.prop("disabled"))
	                    return;
	                var path = getSifarnikPath();
	                if (!path) {
	                    // možda smo namjerno prekinuli dohvaćenje putanje
	                    // Ima smisla kad koristimo funkciju jer onda očito
	                    // ovisi dohvat o nečemu.
	                    return;
	                }
	                var data = dataElement.data("value") || dataElement.val();
	                data = $.trim(data);
	                var valueIsNumber = KUtils.isNumber(data);
	                var filter = null;
	                if (searchColumn && data.length > 0) {
	                    var f = {};
	                    f[searchColumn] = data;
	                    filter = getUnosFilter(f, doOnFilter());
	                }   
	                var filterData = dataElement.data("value");
	                if (dsMethodNumberCheck && valueIsNumber) {
	                    filterData = data;     
	                }
	                if (pkColumn && filterData) {
	                    var f = {};
	                    f[pkColumn] = filterData;
	                    filter = getUnosFilter(f, doOnFilter());
	                }

	                if (!filter) {
	                    filter = doOnFilter();
	                }
	                 
	                if (filterDisabled){
	                	filter = null;
	                }
	                 	                                	
	                dataElement.data("sifarnikPokrenut", true);
	                try {
	                    konto.dialogs.sifarnik({
	                        template: path,
	                        data: {
	                            filter: filter
	                        },
                            postParam: postParam,
	                        odabir: function (data) {
	                            doOnOdabir(data);
	                        },
	                        close: function () {
	                            dataElement.data("sifarnikPokrenut", false);
	                        }
	                    });
	                } catch (e) {
	                    dataElement.data("sifarnikPokrenut", false);
	                    throw e;    
	                }
	            })
                .mousedown(function (e) {
                    e.preventDefault();
                });

            var dsMethodExists = dsMethod || that[callbackName + "Method"];
            if (dsMethodExists) {
                $(dataElement).blur(function (event) {
                	if(dataElement.closest(".modal.kontomodal").find(".btn-odustani-modal:hover").length != 0){
                		return;
                	}
                	
                    if (dataElement.data("sifarnikPokrenut") === true)
                        return;
                    
                    var elementValue = $.trim(dataElement.val());
		             if ((elementValue == "") || ((elementValue == "0") && dsMethodNumberCheck)) { 
                   //if ((elementValue == "" || elementValue == "0") && dsMethodNumberCheck) {
                        // 22.03.2016, ispravljeno da to radi samo za integer polja //U slučaju "0" brišem sadržaj
                        dataElement.val("");
                        doOnClear();
                        return; 
                    }
                    
                    /**
                     * Ako postoji neka vrijednost u elementu, onda ne refresham.
                     */
                    if ((elementValue.length > 0) && (dataElement.data("value") === dataOldValue && dataElement.data("value") !== null)) {
                        return;
                    }

                    if (dsMethod) {
                        var value = dataElement.data("value") || dataElement.val();
                        var params = [value];
                        if (dsMethodParam) {
                            var calculatedValue = eval("(" + dsMethodParam + ")");
                            if (!$.isArray(calculatedValue))
                                params = [calculatedValue];
                            else
                                params = calculatedValue;
                        }
                        if (!dsMethodNumberCheck || KUtils.isNumber(value)) {
                        	var ajaxParams = {
                                method: dsMethod,
                                params: params,
                                done: function (data) {
                                    var newData = $.dsObjectToJS(data);                                                                      
                                    if ((newData == null) && (!dsMethodNumberCheck)){  
                                    	if(dataElement.data("validateExists")){                                  	
                                    		dataElement.focus();
                                    		btn.click();
                                    	}	
                                    }else{
                                    	doOnExit(newData);	
                                    }
                                },
                                fail: doOnFail
                            };                        		
                            /**
                             * Queue se koristi samo kod početnog učitavanja.
                             * Kasnije se koristi običan request koji je asinkroni ili sinkroni ovisno o opciji _ajaxAsync. 
                             */
                        	if (that._ajaxAsync === true && that._readyExecuted === false) {
                        		if (isset(that._allowDuplicateReqs)){ 
                        			that._ajaxQueue.options.allowDuplicateReqs = that._allowDuplicateReqs; //matej 
                        		}
                        		that._ajaxQueue.add({
                        			params: ajaxParams,
                        			name: dependName,
                        			dependedOn: dependencies,
                        			beforeExecute: function() {
                        				if (dsMethodParam) {
                        					var req = this;
	                        				// C/P koda odozgora.
	                        				var calculatedValue = eval("(" + dsMethodParam + ")");
	                        				var params;
				                            if (!$.isArray(calculatedValue))
				                                params = [calculatedValue];
				                            else
				                                params = calculatedValue;
				                         	req.params.params = params;
			                            }	
                        			}
                        		});
                        	}
                        	else {
                            	$.dsDirectCall(ajaxParams, !that._ajaxAsync);
                           	}
                        }
                        else {
                            /**
                             * Trebali smo upisati broj, ali nije broj nego nekakav filter.
                             * doOnClear 
                             *  - da zacrveni polje, ako odustanemo
                             *  - iako nas ne bi smio pustiti iz kućice postoje problemi s focusom,
                             *      pogotovo nakon što se učita grid. Focus možda neće biti na ovoj 
                             *      kućici, pa je ovo više sprečavanje veće greške.
                             */
                            doOnClear(); 
                        }
                    }
                    else {
                        doOnMethod();
                    }
                });
            }   
        },
        /**
         * Metoda proširuje input group na najveću moguću širinu.
         * 
         * Form settings se više ne koriste.
         */
        initForme: function (root) {
            root.find(".input-group").each(function () {
                if ($(this).parents(".form-inline").length == 0)
                    $(this).addClass("col-xs-12");
            });
            var settings = root.find(".form-settings");
            if (settings.length > 0) {
                var sizes = ["", "xs", "sm", "md", "lg"];
                for (var i = 0; i < sizes.length; ++i) {
                    var size = sizes[i];
                    var d = "label-size" + (size == "" ? "" : "-" + size); 
                    if (size == "")
                        size = "xs";
                    var width = settings.data(d);
                    if (width) {
                        // Prije je bilo .form-group label
                        var label = root.find(".form-group .control-label");
                        label.each(function (index, el) {
                            el = $(el);
                            if (el.parents(".form-inline").length > 0)
                                return;
                            var className = el.attr("class");
                            var classes = className.split(/\s+/);
                            var labelHasWidth = false;
                            var m = "col-" + size + "-[0-9]+"; 
                            for (var k = 0; k < classes.length; ++k) {
                                labelHasWidth = classes[k].match(new RegExp(m)) != null;
                                if (labelHasWidth)
                                    break;
                            }
                            if (!labelHasWidth)
                                el.addClass("col-" + size + "-" + width);
                        });

                        root.find(".help-block").each(function (index, el) {
                            el = $(el);
                            if (el.parents(".form-inline").length > 0)
                                return;
                            el.addClass("col-" + size + "-offset-" + width);
                        });
                        root.find(".button-group").each(function (index, el) {
                            el = $(el);
                            if (el.parents(".form-inline").length > 0)
                                return;
                            el.addClass("col-" + size + "-offset-" + width);
                        });
                        root.find(".form-group .checkbox").each(function (index, el) {
                            el = $(el);
                            if (el.parents(".form-inline").length > 0)
                                return;
                            el.addClass("col-" + size + "-offset-" + width);
                        });
                    }       
                }
            }
        },
        /**
         * Formatira float broj nakon upisa. Uzima u obzir thousand separator.
         */
        initFloatInputs: function (root) {
            root.find(".float-value")
                .keypress(function (e) {
                    // FF šalje ovdje backspace, arrows. Chrome, Safari i IE ne šalju.
                    if (e.which == 8 || e.which == 0) // e.which = 0 za non-character keyeve
                        return true;
                    
                    // Provjera valjanog znaka.
                    var c = String.fromCharCode(e.which);
                    var r = new RegExp("[\\-\\d\\" + KUtils.formatSettings.decimalSeparator + "]");
                    if (!r.test(c)) {
                        return false;
                    }
                        
                    // Brišem sadržaj ako je cijeli text selektiran.
                    if (KUtils.isTextSelected(this))
                       this.value = "";
                    
                    if (this.value === "" && c === "-")
                       return true; // puštam minus
                    
                    var sel = KUtils.getInputSelection(this);
                    var oldValue = this.value;
                    var num = oldValue.substring(0, sel.start) + c + oldValue.substring(sel.end);
                    var value = KUtils.parseFloat(num);
                    var isNumber = KUtils.isNumber(value);
                    var decimals = $(this).data("decimals") || 2;
                    
                    var regex = "^-?\\d+(\\.\\d{0," + decimals + "})?$";
                    
                    var reg = new RegExp(regex);
                    return isNumber && reg.test(value.toString());
                })
                .change(function () {
                    var value = $(this).kval();
                    if (!isNaN(value)) {
                    	var decimals = $(this).data("decimals") || 2;
                        $(this).val(KUtils.formatFloat(value, decimals));
                    }
                    else {
                        $(this).val("");
                    }
                });
        },
        initIntInputs: function (root) {
            root.find(".int-value") 
                .keypress(function (e) {
                    // FF šalje ovdje backspace, arrows. Chrome, Safari i IE ne šalju.
                    if (e.which == 8 || e.which == 0) // e.which = 0 za non-character keyeve
                        return true;
                    
                    // Prema regexima dozvoljeni znakovi su samo znamenke, minus i thousand separator. Zbog logičke greške minus se ne može upisati bez klase 'negative-int'
                    var ts = KUtils.formatSettings.thousandSeparator;
                    var c = String.fromCharCode(e.which);
                    var regex = "[\\-\\d" + (ts !== "" ? "\\" + ts : "") + "]";
                    var r = new RegExp(regex);
                    if (!r.test(c)) {
                        return false;
                    }
                        
                    if (KUtils.isTextSelected(this)) {
                        this.value = "";
                    }
                        
                    // Micanjem thousandSeparatora dobivamo broj koji mora biti oblika -?\d*
                    var sel = KUtils.getInputSelection(this);
                    var oldValue = this.value;
                    var num = oldValue.substring(0, sel.start) + c + oldValue.substring(sel.end);
                    
                    //sa klasom "negative-int" radi kako je zamišljeno, no zbog legacy koda ostavljamo i dio da mogu biti samo pozitivni brojevi 
                    if ( $(this).hasClass('negative-int') ){
						num = num.replace(KUtils.formatSettings.thousandSeparator, "");	
					}else{
						num = num.replace(KUtils.formatSettings.thousandSeparator, "") + c;	 //greška je ovaj "+ c", u num već imamo broj koji nam treba.
					}
 
                    if (!(/^-?\d*$/.test(num))) 
                        return false;
                     
                    return true;
                })
                .change(function () {
                	
                    var integer = $(this).kval();
                    if (!isNaN(integer)) {
                    	if (!$(this).hasClass('no-format'))
                       		$(this).val(KUtils.formatInt(integer));
                       	else
                       		$(this).val(integer);
                    }
                    else {
                        $(this).val("");
                    }
                })
                ;
        },
        overrideJQuerySerialization: function () {
            function findKey(arr, key) {
                for (var i = 0; i < arr.length; ++i) {
                    var item = arr[i];
                    if (item.name === key) {
                        return item;
                    }
                }
                return null;
            }
            
            function findKeys(arr, key) {
                var items = [];
                for (var i = 0; i < arr.length; ++i) {
                    var item = arr[i];
                    if (item.name === key)
                        items.push(item);
                }
                return items;
            }

            /**
             * Funkcija radi dobro za sve osim arrayeva sifarnika.
             */
            function insertIntoArray(arr, name, value, replace) {
                if (typeof replace === "undefined")
                    replace = false;
                if (replace) {
                    var item = findKey(arr, name);
                    if (item) {
                        item.value = value;
                        return;
                    }
                }
                arr.push({
                    name: name,
                    value: value
                });
            }
            
            function deleteFromArray(arr, name) {
                for (var i = 0; i < arr.length; ++i) {
                    var item = arr[i];
                    if (item.name === name) {
                        arr.splice(i, 1);
                    }
                }
            }
            
            function insertArrayIntoArray(arr, name, arrValues, replace) {
                if (typeof replace === "undefined")
                    replace = false;
                if (replace) {
                    var items = findKeys(arr, name);
                    if (items) {
                        // Pretpostavka arrValues.length == items.length
                        for (var i = 0; i < items.length; ++i) {
                            items[i].value = arrValues[i];  
                        }
                        return;
                    }
                }
                for (var k = 0; k < arrValues.length; ++k) {
                    arr.push({
                        name: name, 
                        value: arrValues[k]
                    });
                }
            }
            
            function isArrayInput(name) {
                if (name && (name.length > 2)) {
                    return name.slice(-2) == '[]';
                }
                return false;
            }
            
            function removeCheckboxes(values, cbs) {
				var newValues = [];
				$.each(values, function (index, value) {
					var cb = cbs.filter("[name='" + value.name + "']");
					if (cb.length === 0)
						newValues.push(value);
				});
				return newValues;
            }
            
            function addCheckboxes(values, cbs) {
            	cbs.each(function (index, value) {
            		values.push({
            			name: value.name,
            			value: value.checked ? value.value : "off"
            		});
            	});
            }
            
            var originalSerialize = $.fn.serialize;
            //todo: prebaciti u jquery.extend
            $.fn.extend({
                serialize: function () {
					var cbs = $(this).find("input[type=checkbox]");                     
                    var arr = $(this).serializeArray();
                    
                    /**
                     * Checkboxovi su specifični jer se vrijednost uopće ne šalje u POST-u kad nisu checkirani.
                     * Overrideom defaultnog ponašanja dobivamo informaciju da li je checkbox otkvačen ili ga nema.
                     * Ove funkcije uzimaju u obzir i arrayjeve.
                     */
                    arr = removeCheckboxes(arr, cbs);
                    addCheckboxes(arr, cbs);

                    /**
                     * Dorada da se formira datum objekt. Ako je Date u bazi a mi mu pošaljemo 2018 godinu, PHP PostREader to neće ispravno pretvoriti u objekt.
                     * računa se prema value = new DateTime(2018); a to ne da dobar rezultat. Stoga mu postavljamo formatirani datum koji on može protumačiti.
                     */
                    $(this).find("input.konto-input-year").each(function (index, el) {
                    	var value = "";
                    	value = KUtils.formatDate($(el).data("kendoDatePicker").value());                   	
                    	insertIntoArray(arr, el.name, value, true);
                   	});

/* za sad postoji potreba samo na jednom mjestu gdje je to riješeno. Ukoliko se pokaže potreba ponovno ovo aktivirati.
                   	//ako datumi imaju upisanu samo masku onda gazim to sa praznom vrjednošću
                   	$(this).find("input.konto-input-datetime").each(function (index, el) {
                   		var dp = $(el).data("kendoDateTimePicker");
                    	if ((dp) && !(dp.value())) insertIntoArray(arr, el.name, '', true);                   	                    	
                   	});
                   	
                   	$(this).find("input.konto-input-date").each(function (index, el) {
                   		var dp = $(el).data("kendoDatePicker");
                    	if ((dp) && !(dp.value())) insertIntoArray(arr, el.name, '', true);                   	                    	
                   	});
                   	
                   	$(this).find("input.konto-input-time").each(function (index, el) {
                   		var dp = $(el).data("kendoTimePicker");
                    	if ((dp) && !(dp.value())) insertIntoArray(arr, el.name, '', true);                   	                    	
                   	});                   	
                   	
                   	$(this).find("input.konto-input-datetime-ss").each(function (index, el) {
                   		var dp = $(el).data("kendoDateTimePicker");
                    	if ((dp) && !(dp.value())) insertIntoArray(arr, el.name, '', true);                   	                    	
                   	}); 
                   	
					$(this).find("input.konto-input-time-ss").each(function (index, el) {
						var dp = $(el).data("kendoTimePicker");
						if ((dp) && !(dp.value())) insertIntoArray(arr, el.name, '', true);                   	                    	
					});   
*/             	

                    $(this).find(".sifarnik-group input").each(function (index, el) {
                        var value = "";
                        // Handleanje array inputa riješeno ispod.
                        if (isArrayInput(el.name)) {
                            return;
                        }
                        else {
                            value = $(el).data("value");
                            if (!value)
                                value = "";
                            // Ova tvrdnja dolje nije točna. Problemi se javljaju kod brisanja vrijednosti u šifarniku kod ispravka.
                            // Pošalje se kao FIsSet = False i ne promijeni se.
                            // Zbog toga je vraćeno na staro.
                            // OS Inven i slični slučajevi će se morati riješiti na Datasnapu. Na Upisi i Izmijeni se treba provjeriti da li je vrijednost NULL odreagirati prema tome.
//                              /**
//                               * Za NULL vrijednosti ne šaljemo ništa u requestu. Razlog je taj da se poštuje eventualni default iz baze.
//                               * Bitno zbog kompatibilnosti sa starim kodom.
//                               * 
//                               * Npr. OS Inven tablica ima strani ključ na lokaciju, zgradu, sobu i organ. Sad se zapisuje NULL ako ništa ne zadamo 
//                               * za sve navedene vrijednosti. Prije se zapisivalo 0 ili "".
//                               * 
//                               */
//                              if (value === null) {
//                                  deleteFromArray(arr, el.name);  
//                                  return;
//                              }
//                              if (!value)
//                                  value = "";
                        }
                        
                        insertIntoArray(arr, el.name, value, true);
                    });
                    
                    /**
                     * Učitavam sve arrayeve šifarnika. 
                     * Kreiraju se arrayevi valuesa koji se onda postave u već postojeći serijalizirani array
                     * (arr). Nadopunjavanje gornje funkcionalnosti.
                     */
                    var sifArray = $(this).find(".sifarnik-group input[name*='[]']");
                    if (sifArray.length > 0) {
                        var values = {};
                        for (var i = 0; i < sifArray.length; ++i) {
                            var el = sifArray[i];
                            if (!values[el.name]) {
                                values[el.name] = [];
                            }
                            var value = $(el).data("value");
                            if (!value)
                                value = "";
                            
                            values[el.name].push(value);
                        }
                        
                        $.each(values, function (name, value) {
                            insertArrayIntoArray(arr, name, value, true);
                        });
                    }
                    
                    var res = [];
                    $.each(arr, function (key, value) {
                        // encodeURIComponent je bitan zbog primjerice + znaka.
                        // Konkretan primjer: telefonski brojevi pri unosu partnera.
                        var newValue = value.value;
	                    if(typeof newValue === "string" || newValue instanceof String){
	                    	newValue = KUtils.htmlTagCharsEncode(value.value);
	                    }                        
                        res.push(value.name + "=" + encodeURIComponent(newValue));   
                    });                   
                    var resJoined = res.join("&");
                    return resJoined;
                }
            });
        },
        // PG -------------------------------------------------------------
        maskirajDatume: function (root) {
            root.find("input.konto-input-year").each(function(){
                $(this).kendoMaskedTextBox({
                    mask: "0000",         
                    culture: "en-US"
                });
                // rješava problem duplog textboxa
                $(this).removeClass("k-textbox");
            });

            root.find("input.konto-input-date").each(function(){
                $(this).kendoMaskedTextBox({
                    mask: "00.00.0000",         
                    culture: "en-US"
                });
                // rješava problem duplog textboxa
                $(this).removeClass("k-textbox");
            });
            
            root.find("input.konto-input-time").each(function(){
                $(this).kendoMaskedTextBox({
                    mask: "00:00",         
                    culture: "en-US"
                });
            });
            
            root.find("input.konto-input-time-ss").each(function(){
                $(this).kendoMaskedTextBox({
                    mask: "00:00:00",         
                    culture: "en-US"
                });
            });
            
            root.find("input.konto-input-datetime").each(function(){
                $(this).kendoMaskedTextBox({
                	mask: "00.00.0000 00:00",         
                    culture: "en-US"
                });
                // rješava problem duplog textboxa
                $(this).removeClass("k-textbox");
            });
            
            root.find("input.konto-input-datetime-ss").each(function(){
                $(this).kendoMaskedTextBox({
                	mask: "00.00.0000 00:00:00",         
                    culture: "en-US"
                });
                // rješava problem duplog textboxa
                $(this).removeClass("k-textbox");
            });
            
        },
        provjeriPravo: function (method, params, showmsg) {
        	var def = $.Deferred();
        	if (!$.isArray(params))
            	arrParams = [params];
            else
            	arrParams = params;
			var imaPravo = false;
			$.dsDirectCall({
				method: method,
				params: arrParams,
				done: function (data) {
					imaPravo = data;
					if ((imaPravo === false) && showmsg) {
						konto.dialogs.greska({
							title: "Provjera prava",
							content: "Nemate potrebna prava!",
							width: "650px"
						});
					}
					def.resolve(imaPravo);
				}
			});		
			return def.promise();
        },
        provjeriZakljucano: function (method, params, showmsg) {
        	var def = $.Deferred();
        	var zakljucano = true;
        	$.dsDirectCall({
				method: method,
				params: params,
				done: function (data) {
					zakljucano = data;
					if ((zakljucano === true) && showmsg) {
						konto.dialogs.greska({
							title: "Provjera zaključanosti",
							content: "Dokument je zaključan!",
							width: "650px"
						});
					}
					def.resolve(zakljucano);
				}
			});
			return def.promise();
        }
    };
} (jQuery, window.konto = window.konto || {}));